module.exports = __webpack_public_path__ + "static/people_img13-9f4f27409bfcd1e02910308fabf9c35b.png";